import { render, staticRenderFns } from "./VoteSummaryCandidate.vue?vue&type=template&id=01928755&"
import script from "./VoteSummaryCandidate.vue?vue&type=script&lang=js&"
export * from "./VoteSummaryCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports